(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('NctcController', NctcController);

	NctcController.$inject = [ '$scope', 'Nctc', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function NctcController($scope, Nctc, AuthServerProvider, DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {
			Nctc.query({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
				$scope.nctcList = result;
				$scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
				$scope.getTotal(result);
			});
		};

		$scope.getTotal = function (result){
			$scope.total = {};
			$scope.total.digitalMot = 0;
			$scope.total.digitalNonMot = 0;
			$scope.total.dta = 0;
			$scope.total.setTopCount = 0;
			$scope.total.stdRateCharges = 0;
			$scope.total.minimumFee = 0;
			$scope.total.serviceCharge = 0;
			angular.forEach(result,function(nctc,index){
				$scope.total.digitalMot = $scope.total.digitalMot + nctc.digitalMot;
				$scope.total.digitalNonMot = $scope.total.digitalNonMot + nctc.digitalNonMot;
				$scope.total.dta = $scope.total.dta + nctc.dta;
				$scope.total.setTopCount=$scope.total.setTopCount+nctc.setTopCount;
				$scope.total.stdRateCharges =$scope.total.stdRateCharges +nctc.stdRateCharges;
				$scope.total.minimumFee = $scope.total.minimumFee+nctc.minimumFee;
				$scope.total.serviceCharge = $scope.total.serviceCharge + nctc.serviceCharge;
			});
		};

		Nctc.getReportDates(function(result) {
			$scope.reportDate = result;
			$scope.selectedMonth = result[0];

		});

		$scope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(25)
            .withButtons([ {
			//extend: 'csvHtml5', // removing action column TODO : remove action header
			text : 'Export',
			key : '1',
			action : function(e, dt, node, config) {

				Nctc.download({

					date : $scope.selectedMonth.reportDate.substring(0, 10)
				}).$promise.then(function(data) {
					var url = URL.createObjectURL(data.response);
					var link = document.createElement("a");
					link.href = url;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = "Authorization_Fee_summary_For_NCTC_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		} ]).withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>");


	}
})();
